import { AxiosError } from 'axios';
import { createAxiosClient } from '../api/axiosClient';
import { ChangeRequestSource } from '../enums/changeRequest';
import ActionError from './ActionError';
import { TeamUser } from '../interfaces/team';
import { PersonalUser } from '../interfaces/account';
import { isNetworkError } from './errorHandling';

export interface MakeApiCallConfig {
  url: string;
  method: 'GET' | 'POST' | 'PATCH' | 'DELETE';
  data?: Record<string, unknown> | Record<string, unknown>[];
  headers?: Record<string, string>;
  params?: Record<string, unknown>;
  asUser?: TeamUser | PersonalUser | null;
}

export interface MakeApiCallResult {
  data: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  source: ChangeRequestSource | null;
}

// Helper function to handle API calls
export const makeApiCall = async (
  config: MakeApiCallConfig,
  source: ChangeRequestSource | null = null
): Promise<MakeApiCallResult> => {
  try {
    const response = await createAxiosClient({ asUser: config.asUser })(config);
    return {
      data: response.data,
      source,
    } as MakeApiCallResult;
  } catch (error) {
    const axiosError = error as AxiosError;
    // Handle network failures gracefully
    if (isNetworkError(axiosError)) {
      throw new ActionError(
        'Unable to connect to server. Please check your internet connection and try again.',
        0, // Use 0 to indicate network error
        'NETWORK_ERROR'
      );
    }

    // Handle other errors normally
    const msgFromResponse =
      (axiosError.response?.data as { message?: string })?.message || '';
    throw new ActionError(
      msgFromResponse || axiosError.message,
      axiosError.response?.status
    );
  }
};
